

















import Vue from 'vue';
import { formatDate } from '@/web/utils/format';

export default Vue.extend({
  name: 'AffiliatePayoutHistoryModal',
  props: {
    paymentHistory: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    paymentHistoryFelds() {
      return [
        {
          name: 'payment_date',
          title: this.$t('AFFILIATES.TABLE.PAYMENT_DATE'),
        },
        {
          name: 'total',
          title: this.$t('AFFILIATES.TABLE.AMOUNT'),
        },
      ];
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date, 'date-word');
    },
  },
});
